const axios = require('axios');

(() => {
  const selectedCampingRentalCategory = '.camping-rental-category-selection-js';
  const barbecueReservationRentalNum = '.barbecue_reservation_rental_num';
  const deleteCampingRental = '.delete-selected-each-barbecue-camping-rental';
  const moveToBarbecueSecondOptionPage = '.move-to-barbecue-second-option-page';
  const moveToCampingSecondOptionPage = '.move-to-camping-guest-page';
  const barbecueCampingRentalNum = '.barbecue-camping-rental-num';
  const campingRentalModalButton = '.camping-rental-modal-button';
  const campingRentalImage = '.js-camping-rental-img'
  const barbecueCampingRentalNewPath = process.env.JS_BASE_URL + 'customer/barbecue/camping_rental/new';
  var selectedCampingRentalMap = new Map;

  const init = () => {
    if (location.href.indexOf('customer/barbecue/camping_rental') < 1 ) {
      return
    }
    $('body')
      .on('change', selectedCampingRentalCategory, fetchCampingRentals)
      .on('change', barbecueReservationRentalNum, showSeletedCampingRentals)
      .on('change', barbecueCampingRentalNum, showSeletedCampingRentals)
      .on('click', deleteCampingRental, deleteSeletedCampingRentals)
      .on('click', campingRentalModalButton, showCampingRentalModalContent)
      .on('click', campingRentalImage, showSelectedCampingRentalImage)
  }

  const showSelectedCampingRentalImage = e => {
    e.preventDefault();
    const $img = $(e.currentTarget);
    $('.js-slide-target').attr('src', $img.attr('src'))
  }

  const fetchCampingRentals = async e => {
    e.preventDefault();
    const $element = $(e.currentTarget);
    const categoryId = $element.find('option:selected').val();
    axios.get(process.env.JS_BASE_URL + 'customer/barbecue/camping_rental/camping_rentals', {
      params: { camping_rental_category_id: categoryId },
      xsrfHeaderName: 'X-CSRF-Token',
      withCredentials: true
    })
    .then(response => {
      $('.customer_barbecue_options').html(response['data'])
    })
    .catch(error => {
      console.log(error);
      return error;
    })
  }

  const showCampingRentalModalContent = e => {
    const $element = $(e.currentTarget);
    const selectedCampingRentalId = $element[0].dataset.campingRentalId;
    const campingRentals = $('#data-camping-rental').data('camping-rentals');
    const campingRentalImages = $('#data-camping-rental-image').data('camping-rental-images');
    campingRentals.forEach(rental => {
      if (rental.id == selectedCampingRentalId) {
        var targetCampingRentalImages = campingRentalImages.filter(image => image.camping_rental_id == rental.id)
        $('.camping-rental-detail-modal').empty();
        $('.camping-rental-detail-modal').append(buildCampingRentalModal(rental, targetCampingRentalImages));
      }
    })
  }

  const showImage = (images, key) => {
    if (images[key] != null) {
      return `<img class="camping-rental-float-image js-camping-rental-img" src="${images[key].image.admin_show_thumb.url}">`;
    }
    return '';
  }

  const buildCampingRentalModal = (rental, images) => {
    const taxRate = $('#data-tax').data('tax-rate');
    const charge = rental.charge * (1 + taxRate);
    var campingRental =
    `
      <div class="modal-body">
        <div class="price-block">
          <div class="block-left js-slide">
            <img src="${images[0].image.admin_show_thumb.url}" class="js-slide-target">
            <div class="camping-rental-float-images">
              ${showImage(images, 0)}
              ${showImage(images, 1)}
              ${showImage(images, 2)}
              ${showImage(images, 3)}
            </div>
          </div>
          <div class="block-right">
            <div class="brand">${rental.brand_name}</div>
            <div class="title">${rental.rental_name}</div>
            <div class="modal_product_number mb-3">${rental.product_number}</div>
            <div class="price-block">
              <span class="tax">(税込)</span>
              <span class="price">${charge.toLocaleString()}</span>
              <span class="unit">円</span>
            </div>
          </div>
        </div>
        <div class="description modal-description">${rental.description}</div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-success inversion btn-block" data-dismiss="modal">閉じる</button>
      </div>
    `
    return campingRental;
  }

  const showSeletedCampingRentals = async e => {
    const $element = $(e.currentTarget);
    const seletedCampingRentalNum = $element.find('option:selected').val();
    const rest = $element.data('rest')
    const campingRentalId = $element.data('rental-id')

    if (seletedCampingRentalNum > rest) {
      $(`#barbecue-camping-rental-error-message-${campingRentalId}`).empty();
      $(moveToBarbecueSecondOptionPage).prop('disabled', true);
      $(`#barbecue-camping-rental-error-message-${campingRentalId}`).append(`<p class='barbecue-camping-rental-error-message'>上限を超えています</p>`);
      return;
    }
    $(`#barbecue-camping-rental-error-message-${campingRentalId}`).empty();
    $(moveToBarbecueSecondOptionPage).prop('disabled', false);
    const token = $('meta[name="csrf-token"]').attr('content');
    axios({
      url: process.env.JS_BASE_URL + 'customer/barbecue/camping_rental',
      method: 'POST',
      data: { camping_rental_id: campingRentalId, num: seletedCampingRentalNum },
      withCredentials: true,
      headers: {'X-CSRF-Token': token}
    })
    .then(response => {
      $('.plan-block-right').html(response['data'])
      $(`.barbecue_reservation_rental_num-${campingRentalId}`).val(seletedCampingRentalNum)
    })
    .catch(error => {
      console.log(error);
      return error;
    })
  }

  const deleteSeletedCampingRentals = (e) => {
    e.preventDefault();
    const $element = $(e.currentTarget);
    const rentalId = $element.data('rental-id')
    const token = $('meta[name="csrf-token"]').attr('content');
    axios({
      url: process.env.JS_BASE_URL + 'customer/barbecue/camping_rental',
      method: 'DELETE',
      data: { camping_rental_id: rentalId},
      withCredentials: true,
      headers: {'X-CSRF-Token': token}
    })
    .then(response => {
      $(`.barbecue_reservation_rental_num-${rentalId}`).val(0)
      $('.plan-block-right').html(response['data'])
    })
    .catch(error => {
      console.log(error);
      return error;
    })
    return false
  };

  const buildSelectedBarbecueCampingRentalForm = (rental, campingRentalNum, index) => {
    var campingRental =
    `
      <div class="seleted-each-barbecue-camping-rental">
        <li class="selected-each-barbecue-camping-rental-block selected-camping-rental-block-${rental.id}">
          <div class="block-left">
            <div class="title">${rental.rental_name}</div>
            <div class="price-block">
              <span class="tax">（税抜）</span>
              <span class="price">${rental.charge}</span>
              <span class="unit">円</span>
            </div>
            <p class="selected-barbecue-camping-rental-error-message-frame" id="selected-barbecue-camping-rental-error-message-${rental.id}"></p>
          </div>
          <div class="block-right">
            <div class="select">
              <input class="barbecue-camping-rental-id" name="barbecue_reservation[barbecue_reservation_rentals_attributes][${index}][camping_rental_id]" id="barbecue_reservation_barbecue_reservation_rentals_attributes_${index}_camping_rental_id" type="hidden" value="${rental.id}">
              <select class="barbecue-camping-rental-num" name="barbecue_reservation[barbecue_reservation_rentals_attributes][${index}][num]" id="barbecue_reservation_barbecue_reservation_rentals_attributes_${index}_num">
                <option selected="selected" value="${campingRentalNum}">${campingRentalNum}</option>
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
                <option value="6">6</option>
                <option value="7">7</option>
                <option value="8">8</option>
                <option value="9">9</option>
                <option value="10">10</option>
              </select>
            </div>
            <div class="link">
              <a class="text-link delete-selected-each-barbecue-camping-rental" href="#">削除</a>
            </div>
          </div>
        </li>
      </div>
    `
    return campingRental;
  }

  const buildSelectedCampingCampingRentalForm = (rental, campingRentalNum, index) => {
    var campingRental =
    `
      <div class="seleted-each-barbecue-camping-rental">
        <li class="selected-each-barbecue-camping-rental-block selected-camping-rental-block-${rental.id}">
          <div class="block-left">
            <div class="title">${rental.rental_name}</div>
            <div class="price-block">
              <span class="tax">（税抜）</span>
              <span class="price">${rental.charge}</span>
              <span class="unit">円</span>
            </div>
            <p class="selected-barbecue-camping-rental-error-message-frame" id="selected-barbecue-camping-rental-error-message-${rental.id}"></p>
          </div>
          <div class="block-right">
            <div class="select">
              <input class="barbecue-camping-rental-id" name="camping_reservation[camping_reservation_rentals_attributes][${index}][camping_rental_id]" id="camping_reservation_camping_reservation_rentals_attributes_${index}_camping_rental_id" type="hidden" value="${rental.id}">
              <select class="barbecue-camping-rental-num" name="camping_reservation[camping_reservation_rentals_attributes][${index}][num]" id="camping_reservation_camping_reservation_rentals_attributes_${index}_num">
                <option selected="selected" value="${campingRentalNum}">${campingRentalNum}</option>
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
                <option value="6">6</option>
                <option value="7">7</option>
                <option value="8">8</option>
                <option value="9">9</option>
                <option value="10">10</option>
              </select>
            </div>
            <div class="link">
              <a class="text-link delete-selected-each-barbecue-camping-rental" href="#">削除</a>
            </div>
          </div>
        </li>
      </div>
    `
    return campingRental;
  }

  $(init);
})();

